<div class="m-subheader" appunwraptag="">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">
                My Assessment Agency
            </h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a routerLink=".." class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">
                    -
                </li>
                <li class="m-nav__item">
                    <span class="m-nav__link">
                        <span>
                            View Assessment Agency Details
                        </span>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content" style="padding-right: 25px!important;">
    <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet">
            <div class="m-content">
                <div class="row">
                    <div class="col-xl-3 col-lg-4">
                        <div class="m-portlet m-portlet--full-height  ">
                            <div class="m-portlet__body">
                                <div class="m-card-profile">
                                    <div class="m-card-profile__title m--hide">
                                        Your Profile
                                    </div>
                                    <div class="m-card-profile__pic">
                                        <div class="m-card-profile__pic-wrapper">
                                            <img src="./assets/app/media/img/users/user4.jpg" alt="">
                                        </div>
                                    </div>
                                    <div class="m-card-profile__details">
                                        <span
                                            class="m-card-profile__name">{{generalDetailsFormGroup.get('nameOfAssAgency').value.value}}</span>
                                        <a href=""
                                            class="m-card-profile__email m-link">{{generalDetailsFormGroup.get('assAgencyId').value.value}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-8">
                        <div class="m-portlet m-portlet--full-height m-portlet--tabs  ">
                            <div class="m-portlet__head">
                                <div class="m-portlet__head-tools">
                                    <ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
                                        role="tablist">
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link active" data-toggle="tab"
                                                href="#assigned-job-roles" role="tab">
                                                <i class="flaticon-share m--hide"></i> General Details
                                            </a>
                                        </li>
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#certifications"
                                                role="tab">
                                                Financial Details
                                            </a>
                                        </li>
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#education"
                                                role="tab">
                                                Associations
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                                <div class="m-portlet__head-tools">
                                    <h3 class="m-portlet__head-text">
                                        <span class="push-right">
                                            <button
                                                *ngIf="generalDetailsFormGroup.get('role').value.value !== 'Assessment PMU'"
                                                type="button" class="btn btn-secondary notranslate"
                                                (click)="editProfile()">
                                                Edit Profile
                                            </button>
                                            <button type="button" class="btn btn-secondary" (click)="location.back()">
                                                Back
                                            </button>
                                        </span>
                                    </h3>
                                </div>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane active" id="assigned-job-roles">
                                    <form class="m-form m-form--fit m-form--label-align-right">
                                        <div class="m-portlet__body">
                                            <div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        General Details
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" [formGroup]="generalDetailsFormGroup">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Name of the Organization
                                                                :</label>
                                                            <input formControlName="nameOfAssAgency" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                            <span class="m-form__help metaLink-style">View Profile
                                                                Details</span>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Assessment Agency ID
                                                                :</label>
                                                            <input formControlName="assAgencyId" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Type of Assessment Agency
                                                                :</label>
                                                            <input formControlName="typeOfAA" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Overall Experience :</label>
                                                            <input formControlName="overallExp" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <!-- <div class="row">
														<div class="form-group m-form__group col-lg-6">
															<label for="exampleInputEmail1">AA Affiliation :</label>
															<input formControlName="aaAfilliation" type="email" class="form-control m-input m-input--solid" id="exampleInputEmail1"
															 aria-describedby="emailHelp" >
														</div>

                                                    </div> -->
                                                    <!-- <div class="col-lg-6">
															<label for="exampleInputEmail1">Affiliated with other SSC :</label>
															<input formControlName="affWithSsc" type="email" class="form-control m-input m-input--solid" id="exampleInputEmail1"
															 aria-describedby="emailHelp" >
														</div> -->
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Available Mode of
                                                                Assessment:</label>
                                                            <!-- <input formControlName="modeOfAssessment" type="email" class="form-control m-input m-input--solid" id="exampleInputEmail1"
															 aria-describedby="emailHelp" > -->
                                                            <select multiple="" formControlName="modeOfAssessment"
                                                                class="form-control m-input m-input--air notranslate"
                                                                id="exampleSelect2">
                                                                <option *ngFor="let ass of assessmetModeList"
                                                                    [value]="ass">{{ass}}</option>
                                                            </select>


                                                        </div>
                                                        <div *ngIf="generalDetailsFormGroup.get('otherModeOfAssessment').value !== 'N/A'"
                                                            class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Others :</label>
                                                            <input type="email" formControlName="otherModeOfAssessment"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Languages Known for
                                                                Assessment:</label>
                                                            <select multiple="" formControlName="languageKnown"
                                                                class="form-control m-input m-input--air notranslate"
                                                                id="exampleSelect2">
                                                                <option *ngFor="let lang of languageList"
                                                                    [value]="lang">{{lang}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">ISO Certification :</label>
                                                            <input type="email" formControlName="isoCertification"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Upload ISO Certification
                                                                Documents :</label>
                                                            <p class="form-control m-input m-input--solid file-clickable"
                                                                (click)="previewIsoDoc()">ISO Certification Document</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Single Point of Contact Info:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" [formGroup]="singlePointInfoFormGroup">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Name of the SPOC :</label>
                                                            <input formControlName="nameOfSpoc" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                            <span class="m-form__help metaLink-style">View Profile
                                                                Details</span>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label for="exampleInputEmail1">Email Address :</label>
                                                            <input formControlName="email" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label for="exampleInputEmail1">Phone Number :</label>
                                                            <input formControlName="phoneNumber" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Address Details:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" [formGroup]="addressDetailFormGroup">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Address :</label>
                                                            <textarea formControlName="address"
                                                                class="form-control m-input m-input--air notranslate"
                                                                id="exampleTextarea" rows="3"></textarea>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Incorporation Year :</label>
                                                            <input formControlName="incorpYear" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Nearby Landmark :</label>
                                                            <input formControlName="landMark" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Pincode :</label>
                                                            <input formControlName="pinCode" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">State / Union Territory
                                                                :</label>
                                                            <input formControlName="state" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">District :</label>
                                                            <input formControlName="district" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Tehsil / Mandal /Block
                                                                :</label>
                                                            <input formControlName="tehsil" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">City / Village / Town
                                                                :</label>
                                                            <input formControlName="city" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Parliamentary Constituency
                                                                :</label>
                                                            <input formControlName="parliamentConsti" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Address Proof :</label>
                                                            <p class="form-control m-input m-input--solid file-clickable"
                                                                (click)="viewAddressProof()">Address Proof Document</p>

                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Other Information:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" [formGroup]="otherInformationFormGroup">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Candidate Assessed till date
                                                                :</label>
                                                            <input formControlName="candidateAssessedDate" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Total staff :</label>
                                                            <input formControlName="numberOfAdminStaff" type="email"
                                                                class="form-control m-input m-input--solid notranslate"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Working under other Projects
                                                                :</label>
                                                            <textarea formControlName="workingUnderProject"
                                                                class="form-control m-input m-input--air notranslate"
                                                                id="exampleTextarea" rows="3"></textarea>

                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Key achievements :</label>
                                                            <textarea formControlName="keyAchievements"
                                                                class="form-control m-input m-input--air notranslate"
                                                                id="exampleTextarea" rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="tab-pane " id="certifications">
                                    <form class="m-form m-form--fit m-form--label-align-right">
                                        <div class="m-portlet__body">
                                            <div>
                                                <div class="m-content">
                                                    <h5 class="padding align-center">
                                                        Training Certificate of Assessor
                                                    </h5>

                                                </div>
                                                <div *ngIf="fileData.yearOfEstablishmentDetails" class="row">
                                                    <div class="m-portlet__body">
                                                        <div class="form-group col-lg-12 m-form__group row">
                                                            <label for="example-text-input"
                                                                class="col-7 col-form-label">Year of
                                                                Establishment:</label>
                                                            <div class="col-3">
                                                                <input class="form-control m-input notranslate"
                                                                    type="text"
                                                                    [value]="fileData.yearOfEstablishmentDetails?.year"
                                                                    [disabled]="true" id="example-text-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="m-portlet__body">
                                                        <div class="form-group col-lg-12 m-form__group row"
                                                            *ngFor="let finance of financialTurnOver">
                                                            <label for="example-text-input"
                                                                class="col-6 col-form-label">Financial Year
                                                                {{finance.duration.endYear}}-{{finance.duration.startYear}}
                                                                ( INR in Lakhs ):</label>
                                                            <div class="col-3">
                                                                <input class="form-control m-input notranslate"
                                                                    type="text" [disabled]="true"
                                                                    [value]=finance.annualTurnOver
                                                                    id="example-text-input">
                                                            </div>
                                                            <div (click)="opeFile(finance.supportingCACertificate)"
                                                                class="col-3 preview-uploaded-file"
                                                                style="cursor:pointer">
                                                                Preview Uploaded File
                                                            </div>
                                                        </div>

                                                        <div *ngIf="isbankdetails">
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Account Holder Name:</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]="bankdetails.accountHolderName || 'N/A'"
                                                                        id="example-text-input">
                                                                </div>
                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Account Type:</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]="bankdetails.accountType || 'N/A'"
                                                                        id="example-text-input">
                                                                </div>
                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Bank Key ( IFSC
                                                                    Code):</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]=bankdetails.ifscCode
                                                                        id="example-text-input">
                                                                </div>
                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Bank Account
                                                                    :</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]=bankdetails.accountNumber
                                                                        id="example-text-input">
                                                                </div>

                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Bank Name
                                                                    :</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]="bankdetails.bankName || 'N/A'"
                                                                        id="example-text-input">
                                                                </div>

                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">Bank Address
                                                                    :</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]="bankdetails.bankAddress || 'N/A'"
                                                                        id="example-text-input">
                                                                </div>

                                                            </div>
                                                            <div class="form-group col-lg-12 m-form__group row">
                                                                <label for="example-text-input"
                                                                    class="col-6 col-form-label">PAN
                                                                    Identification
                                                                    Number
                                                                    :</label>
                                                                <div class="col-6">
                                                                    <input class="form-control m-input notranslate"
                                                                        type="text" [disabled]="true"
                                                                        [value]=bankdetails.panNo
                                                                        id="example-text-input">
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="tab-pane " id="education">
                                    <form class="m-form m-form--fit m-form--label-align-right">
                                        <div class="m-portlet__body">
                                            <div>
                                                <div class="m-portlet__body">
                                                    <div class="m-portlet__head">
                                                        <div class="m-portlet__head-caption">
                                                            <div class="m-portlet__head-title">
                                                                <h3 class="m-portlet__head-text m--font-primary">
                                                                    <span class="heading-style">Empanelled SSC</span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table class="table table-striped m-table"
                                                        *ngIf="associateSScData && associateSScData.length > 0">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Sector (ID)
                                                                </th>
                                                                <th>
                                                                    Sub - Sector
                                                                </th>
                                                                <th>
                                                                    State
                                                                </th>
                                                                <th>
                                                                    District
                                                                </th>
                                                                <th>
                                                                    Job Role Name
                                                                </th>
                                                                <!-- <th>
                                                                    Action
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="notranslate">
                                                            <tr *ngFor="let data of sscData, let i = index;">
                                                                <td>{{data.sectorname || 'N/A'}}</td>
                                                                <td>
                                                                    <div
                                                                        *ngIf="data.linkedSectors && data.linkedSectors.subSectors; else noData">
                                                                        <div
                                                                            *ngFor="let subSec of data.linkedSectors.subSectors">
                                                                            {{subSec.name || 'N/A'}}
                                                                        </div>
                                                                    </div>
                                                                    <ng-template #noData>N/A</ng-template>
                                                                </td>
                                                                <td>
                                                                    <div>{{getState(data)}}</div>
                                                                </td>
                                                                <td>{{getDistrict(data)}}</td>
                                                                <td>{{getJobRoleName(data)}}</td>
                                                                <!-- <td>
																			<div class="dropdown dropup">
																				<a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
																				 data-toggle="dropdown" aria-expanded="false">
																					<i class="la la-ellipsis-h"></i>
																				</a>
																				<div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
																					<a class="dropdown-item">View Details</a>
																				</div>
																			</div>
																		</td> -->
                                                            </tr>
                                                            <tr *ngIf="sscData.length === 0"
                                                                style="color:grey;font-size:17px">
                                                                <td colspan="8">
                                                                    <p style="text-align:center;">No Data Found</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="m-portlet__body">
                                                    <div class="m-portlet__head">
                                                        <div class="m-portlet__head-caption">
                                                            <div class="m-portlet__head-title">
                                                                <h3 class="m-portlet__head-text m--font-primary">
                                                                    <span class="heading-style">Associated
                                                                        Assessors</span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="m-portlet__head-tools">
															<ul class="m-portlet__nav">
																<li class="m-portlet__nav-item">
																	<button type="button" class="btn m-btn--pill    btn-outline-info btn-sm m-btn m-btn--custom">Link
																		Assessors</button>
																</li>

															</ul>
														</div> -->
                                                    </div>
                                                    <table class="table table-striped m-table"
                                                        *ngIf="associateAa && associateAa.length > 0">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Assessor ID
                                                                </th>
                                                                <th>
                                                                    Assessor Name
                                                                </th>
                                                                <th>
                                                                    Mobile Number
                                                                </th>
                                                                <th>
                                                                    Email
                                                                </th>
                                                                <!-- <th>
                                                                    Certified SSC
                                                                </th>
                                                                <th>
                                                                    Availability
                                                                </th> -->
                                                                <th>
                                                                    Linking Type
                                                                </th>
                                                                <!-- <th>
                                                                    Action
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="notranslate">
                                                            <tr *ngFor="let linkedAA of associateAa;">
                                                                <td>{{linkedAA.userName?linkedAA.userName: 'N/A'}}</td>
                                                                <td>{{linkedAA.name?linkedAA.name: 'N/A'}}</td>
                                                                <td>{{linkedAA.phone?linkedAA.phone: 'N/A'}}</td>
                                                                <td>{{linkedAA.email?linkedAA.email: 'N/A'}}</td>
                                                                <td>{{linkedAA.associations?.linkedType?linkedAA.associations.linkedType:
                                                                    'N/A'}}</td>
                                                                <!-- <td>{{linkedAA.associations?.validity?.fromDate?linkedAA.associations.validity.fromDate: 'N/A'}}</td>
                                                                <td>{{linkedAA.associations?.validity?.toDate?linkedAA.associations.validity.toDate: 'N/A'}}</td> -->
                                                                <!-- <td>
                                                                    <div class="dropdown dropup">
                                                                        <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="false">
                                                                            <i class="la la-ellipsis-h"></i>
                                                                        </a>
                                                                        <div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
                                                                            <a class="dropdown-item">View Details</a>
                                                                        </div>
                                                                    </div>
                                                                </td> -->
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>